import React, {useState, useContext, PropsWithChildren} from 'react'
import {XpertKnowledgeService} from '../../services/XpertKnowledge'
import {TryPromptXpertKnowledgeTutorialBody} from '../../services/XpertKnowledge/type'
import {XpertKnowledgeSectionDto} from '../../services/XpertKnowledgeSection/type'
import {useXpertKnowledgeContext} from '../XpertKnowledge/XpertKnowledgeContext'
import {useParams} from 'react-router-dom'

interface XpertKnowledgeTryPromptContext {
  tryPromptXpertKnowledgeTutorial: (body: TryPromptXpertKnowledgeTutorialBody) => Promise<void>
  setIsTryPromptModalLoading: (loading: boolean) => void
  emulatedXpertKnowledgeSection: XpertKnowledgeSectionDto[]
  isTryPromptModalLoading: boolean
}

const Context = React.createContext<XpertKnowledgeTryPromptContext>(null as any)

export const XpertKnowledgeTryPromptContextProvider: React.FC<PropsWithChildren> = ({children}) => {
  const [emulatedXpertKnowledgeSection, setEmulatedXpertKnowledgeSection] = useState<XpertKnowledgeSectionDto[]>([])
  const [isTryPromptModalLoading, setIsTryPromptModalLoading] = useState<boolean>(false)
  const {xpertKnowledgeId} = useParams<{xpertKnowledgeId: string}>()

  const tryPromptXpertKnowledgeTutorial = async (body: TryPromptXpertKnowledgeTutorialBody) => {
    try {
      setIsTryPromptModalLoading(true)
      const tutorialMock = await XpertKnowledgeService.tryPrompt(xpertKnowledgeId!, body)
      setEmulatedXpertKnowledgeSection(tutorialMock.sections)
    } catch (error) {
      console.error('Error Testing Xpert Knowledge Prompt:', error)
    } finally {
      setIsTryPromptModalLoading(false)
    }
  }

  return (
    <Context.Provider
      value={{
        tryPromptXpertKnowledgeTutorial,
        setIsTryPromptModalLoading,
        isTryPromptModalLoading,
        emulatedXpertKnowledgeSection,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useXpertKnowledgeTryPromptContextProvider = () => useContext(Context)
